module.exports = __webpack_public_path__ + "static/media/westbourne.aacb2b31.png";